module.exports = __webpack_public_path__ + "static/media/icon_image_a.969f7061.svg";